export const homeAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }